// src/services/preferencesService.js
// Wrapper de persistance backend de la préférence de langue du membre.
//
// ✅ ACTIVÉ en S5 (2026-07-01) : PUT /members/:id accepte désormais
// `preferred_language` (bloc dédié ENUM validé contre organizations.supported_locales,
// self-only). La langue choisie via le switcher est persistée en base ET en
// localStorage (cf. LanguageContext) → réconciliation cross-device au login
// (le payload user du login renvoie preferred_language).
//
// Rollback : repasser ce flag à false (localStorage reste la source côté client).

import { put } from '../utils/apiClient'

export const PREFERRED_LANGUAGE_BACKEND_ENABLED = true

export async function updatePreferredLanguage(lang, memberId) {
  if (!PREFERRED_LANGUAGE_BACKEND_ENABLED) {
    return { skipped: true }
  }
  if (!memberId) return { skipped: true, reason: 'no_member_id' }
  return put(`/members/${memberId}`, { preferred_language: lang })
}
